import { useGetReceivedRequests } from '../../../api/query_hooks/request';
import { Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const CommissionList = ({selectedRequest}) => {

    const requestsQuery = useGetReceivedRequests();


    return (
        <>
            {requestsQuery.isLoading &&
                <div className='m-auto'>
                    <Spinner animation="border" role="status" aria-describedby="loading" />
                </div>
            }
            {requestsQuery.isError && 
                <div className='m-auto'>
                    {requestsQuery.error.response?.data}
                </div>
            }
            {requestsQuery.isSuccess &&
                <div className="bg-dark d-flex flex-column flex-grow-1 px-2 py-2 rounded-bottom">
                    <ul className='bg-darker d-flex flex-column flex-grow-1 col-12 p-0 m-0 border border-black overflow-y-auto'>
                        {requestsQuery.data?.data.map((request, index) => (
                            <li key={index} className={(parseInt(request.id) === parseInt(selectedRequest)) ? 'bg-dark' : 'hov-bg-2'}>
                                <Link to={'/certificates/expert/commissions/'+request.id} className='col-12 d-flex justify-content-between align-items-center px-4 py-2 border border-black'>
                                    <div className=''>
                                        <p>From: {request.fromUser.username}</p>
                                        <p className='m-0'>Artwork: {request.artwork.title}</p>
                                    </div>
                                    <div>
                                        <p>{new Date(request.createdAt).toLocaleDateString()}</p>
                                        <p className="text-mini flex-center m-0 border border-white-50 rounded">{request.status}</p>
                                    </div>
                                </Link>
                            </li>
                        ))}
                        {!requestsQuery.data?.data.length &&
                            <p className='text-center my-auto'>You haven't received any requests yet</p>
                        }
                    </ul>
                </div>
            }
        </>
    );
};

export default CommissionList;